import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';

const carpetImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/2chq71rz_image.png",
    alt: "Nettoyage tapis persan oriental sur machine professionnelle Komman - AQUABLUENET Essonne"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/pjlwfbvm_image.png",
    alt: "Lavage tapis persan rouge - Machine automatique à brosses rotatives - Pressing AQUABLUENET"
  }
];

const features = [
  "Tapis persan & tapis oriental",
  "Kilim & tapis berbère",
  "Tapis shaggy & tapis de salon",
  "Tapis en laine & tapis en soie",
  "Tapis faits main & anciens",
  "Moquettes & carpettes",
  "Tapis de bureau (pro)",
  "Détachage & désinfection"
];

export const CarpetCleaningSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0205B3] via-blue-700 to-blue-900 text-white relative overflow-hidden" data-testid="carpet-cleaning-section">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
            <span>🧿 SPÉCIALITÉ DE LA MAISON</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black mb-4">
            Nettoyage de Tapis & Moquette en Essonne (91)
          </h2>
          <p className="text-xl text-blue-50 max-w-3xl mx-auto leading-relaxed">
            <strong>AQUABLUENET</strong> est <strong>spécialiste du nettoyage de tapis et moquettes</strong> dans l'Essonne avec <strong>2 établissements</strong> à <strong>Longpont-sur-Orge (91310)</strong> et <strong>Mennecy (91540)</strong>. Nous lavons <strong>tapis persan, tapis oriental, kilim, tapis berbère, tapis en laine, tapis en soie, tapis shaggy, moquettes et carpettes</strong> sur machine professionnelle à brosses rotatives.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            {carpetImages.map((img) => (
              <div key={img.url} className="rounded-2xl overflow-hidden shadow-2xl aspect-square">
                <img src={img.url} alt={img.alt} title={img.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <h3 className="text-2xl font-bold mb-4">Nos prestations tapis & moquette</h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-green-300 flex-shrink-0 mt-0.5" />
                    <span className="text-blue-50">{f}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <h3 className="text-xl font-bold mb-2">Technologie professionnelle Komman</h3>
              <p className="text-blue-50 leading-relaxed">
                Machine à <strong>brosses rotatives automatiques</strong> + traitement écologique <strong>Lagoon 0% Perchlo</strong>. Idéal pour les <strong>fibres délicates</strong> (laine, soie) comme pour les <strong>tapis très sales</strong>. Séchage contrôlé, restauration des franges, détachage spécifique.
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              <Button
                className="bg-white text-[#0205B3] hover:bg-blue-50 font-bold text-base px-6 py-5"
                onClick={() => { window.location.href = 'tel:0169807375'; }}
                data-testid="carpet-call-longpont-btn"
              >
                <Phone className="mr-2 h-5 w-5" />
                Longpont : 01 69 80 73 75
              </Button>
              <Button
                className="bg-green-600 hover:bg-green-700 text-white font-bold text-base px-6 py-5"
                onClick={() => { window.location.href = 'tel:0984509942'; }}
                data-testid="carpet-call-mennecy-btn"
              >
                <Phone className="mr-2 h-5 w-5" />
                Mennecy : 09 84 50 99 42
              </Button>
              <Link to="/etablissements">
                <Button variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-[#0205B3] font-bold text-base px-6 py-5 bg-transparent">
                  <MapPin className="mr-2 h-5 w-5" />
                  Voir nos 2 pressings
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* SEO rich paragraph */}
        <div className="mt-12 bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
          <h3 className="text-lg font-bold mb-3">Zones desservies pour le nettoyage tapis & moquette</h3>
          <p className="text-sm text-blue-100 leading-relaxed">
            <strong>Pressing tapis Essonne</strong> : nous nettoyons les tapis et moquettes des particuliers et professionnels de <strong>Longpont-sur-Orge, Mennecy, Montlhéry, Linas, Arpajon, Sainte-Geneviève-des-Bois, Brétigny-sur-Orge, La Ville du Bois, Ballainvilliers, Marcoussis, Nozay, Saint-Michel-sur-Orge, Villiers-sur-Orge, Villemoisson-sur-Orge, Ballancourt-sur-Essonne, Lisses, Écharcon, Fontenay-le-Vicomte, Vert-le-Petit, Ormoy, Chevannes, Champcueil, Auvernaux, Saintry-sur-Seine, Villebon-sur-Yvette, Champlan, Épinay-sur-Orge</strong> et toute l'Essonne (91).
          </p>
        </div>
      </div>
    </section>
  );
};
